import { i18n } from '/shared/translations/i18n';

const VEHICLE_TYPE_LABELS: Record<string, { fallback: string; key: string }> = {
  cars: { key: 'business:QuestionPage.forms.vehicleTypeSelector.para2', fallback: 'Cars' },
  vans: { key: 'business:QuestionPage.forms.vehicleTypeSelector.para3', fallback: 'Vans' },
  trucks: { key: 'business:QuestionPage.forms.vehicleTypeSelector.para4', fallback: 'Trucks' },
};

export default function transportVehicleTypeLabel({ vehicleType }: { vehicleType?: string }): string {
  const label = VEHICLE_TYPE_LABELS[vehicleType ?? ''];
  return label ? i18n.t(label.key, label.fallback) : (vehicleType ?? '');
}
